export const SIDE_MARKETS_TAB_SORT_STORAGE_KEY =
  "orderly_side_markets_tab_sort";

export const SIDE_MARKETS_SEL_TAB_KEY = "orderly_side_markets_sel_tab_key";
